import { i18n } from '@/locales';
import { BAEMIN_ONE, O2PLUS_FOR_ADDRESS, YOGI_DELIVERY, } from './orderAgencyType';
const lc = 'views.delivery_history.table_header.';
export const tableHeaders = [
    {
        title: '',
        value: 'isShare',
        sortable: false,
        width: 10,
    },
    {
        title: i18n.t(`${lc}today_number`),
        value: 'todayNumber',
        width: 90,
    },
    {
        title: i18n.t(`${lc}hub_name`),
        value: 'hubName',
        sortable: false,
        width: 131,
    },
    {
        title: i18n.t(`${lc}allocated_hub_name`),
        value: 'allocatedHubName',
        sortable: false,
        width: 131,
    },
    {
        title: i18n.t(`${lc}store_name`),
        value: 'storeName',
        sortable: false,
        width: 131,
    },
    {
        title: i18n.t(`${lc}worker_name`),
        value: 'workerName',
        sortable: false,
        width: 85,
    },
    {
        title: i18n.t(`${lc}allocated_worker_phone`),
        value: 'allocatedWorkerPhone',
        sortable: false,
        width: 115,
    },
    {
        title: i18n.t(`${lc}store_phone`),
        value: 'storePhone',
        sortable: false,
        width: 115,
    },
    {
        title: i18n.t(`${lc}receiver_phone`),
        value: 'receiverPhone',
        sortable: false,
        width: 115,
    },
    {
        title: i18n.t(`${lc}drop_address`),
        value: 'dropAddress',
        sortable: false,
        width: 282,
    },
    {
        title: i18n.t(`${lc}memo`),
        value: 'memo',
        sortable: false,
        width: 283,
    },
    {
        title: i18n.t(`${lc}order_caution`),
        value: 'orderCaution',
        sortable: false,
        width: 68,
    },
    {
        title: i18n.t(`${lc}status_code`),
        value: 'translatedStatus',
        sortable: false,
        width: 64,
    },
    {
        title: i18n.t(`${lc}ordered_at`),
        value: 'orderedAt',
        width: 150,
    },
    {
        title: i18n.t(`${lc}finished_at`),
        value: 'finishedAt',
        sortable: false,
        width: 150,
    },
    // 취소시간
    {
        title: i18n.t(`${lc}canceled_at`),
        value: 'canceledAt',
        sortable: false,
        width: 150,
    },
    // 출발지 메모
    {
        title: i18n.t(`${lc}store_memo`),
        value: 'storeMemo',
        sortable: false,
        width: 336,
    },
    // 출발지 주소
    {
        title: i18n.t(`${lc}pickup_address`),
        value: 'pickupAddress',
        sortable: false,
        width: 336,
    },
    // 대행료
    {
        title: i18n.t(`${lc}purchase_delivery_charge`),
        value: 'purchaseDeliveryCharge',
        sortable: false,
        width: 100,
    },
    // 결제금액
    {
        title: i18n.t(`${lc}order_amount`),
        value: 'orderAmount',
        sortable: false,
        width: 100,
    },
    // 결제장법
    {
        title: i18n.t(`${lc}pay_type`),
        value: 'payType',
        sortable: false,
        width: 120,
    },
    // 라이더에게 지불방식
    {
        title: i18n.t(`${lc}delivery_pay_type`),
        value: 'deliveryPayType',
        sortable: false,
        width: 136,
    },
    // 배달번호
    {
        title: i18n.t(`${lc}order_id`),
        value: 'orderId',
        sortable: false,
        width: 88,
    },
    // 운행거리
    {
        title: i18n.t(`${lc}delivery_distance`),
        value: 'deliveryDistance',
        sortable: false,
        width: 68,
    },
];
/** 주소기반 */
export const orderAgencyOptions = [
    /** 전체 */
    {
        text: i18n.t('common.all'),
        value: 'ALL',
    },
    /** 요기 */
    {
        text: i18n.t('common.yogi_delivery'),
        value: YOGI_DELIVERY,
    },
    /** 배민 */
    {
        text: i18n.t('common.baemin_one'),
        value: BAEMIN_ONE,
    },
    /** 오투 */
    {
        text: i18n.t('common.o2plus_for_address'),
        value: O2PLUS_FOR_ADDRESS,
    },
];
/** 발주 유형 */
export const ownerTypeOptions = [
    /** 전체 */
    {
        text: i18n.t('common.hub_type.all'),
        value: 'ALL',
    },
    /** 자사건 */
    {
        text: i18n.t('common.hub_type.own'),
        value: 'OWN',
    },
    /** 공유건 */
    {
        text: i18n.t('common.hub_type.share'),
        value: 'SHARED',
    },
    /** B2B */
    {
        text: i18n.t('common.hub_type.b2b'),
        value: 'B2B',
    },
];
// 결제 유형 검색 조건
export const payTypeOptions = [
    {
        text: i18n.t('common.pay_type.all'),
        value: 'ALL',
        field: '',
    },
    {
        text: i18n.t('common.pay_type.pre_pay'),
        value: 'PRE_PAY_AMOUNT',
        field: 'prePayAmount',
    },
    {
        text: i18n.t('common.pay_type.pay_card'),
        value: 'PAY_CARD_AMOUNT',
        field: 'payCardAmount',
    },
    {
        text: i18n.t('common.pay_type.pay_cash'),
        value: 'PAY_CASH_AMOUNT',
        field: 'payCashAmount',
    },
];
// 배달/퀵 서비스
export const orderTypeOptions = [
    {
        title: 'common.order_type.all',
        value: 'ALL',
    },
    {
        title: 'common.order_type.delivery',
        value: 'DELIVERY',
    },
    {
        title: 'common.order_type.quick',
        value: 'QUICK',
    },
];
// 검색란 검색유형
export const searchFieldTypeOptions = [
    {
        title: 'views.delivery_history.table_header.store_name',
        value: 'STORE_NAME',
        field: 'storeName',
    },
    {
        title: 'views.delivery_history.table_header.worker_name',
        value: 'ALLOCATED_WORKER_NAME',
        field: 'allocatedWorkerName',
    },
    {
        title: 'views.delivery_history.table_header.allocated_hub_name',
        value: 'ALLOCATED_HUB_NAME',
        field: 'allocatedHubName',
    },
    {
        title: 'views.delivery_history.table_header.hub_name',
        value: 'HUB_NAME',
        field: 'hubName',
    },
    // 도착지 주소 검색 시 https://github.com/barogo/zoo/issues/4214 티켓 처리전에는
    // dropAddressJibun 필드에서만 like 검색하는 방향으로 우선 정리함
    {
        title: 'views.delivery_history.table_header.drop_address',
        value: 'DROP_ADDRESS_JIBUN',
        field: 'dropAddressJibun',
    },
    {
        title: 'views.delivery_history.table_header.today_number',
        value: 'TODAY_NUMBER',
        field: 'todayNumber',
    },
    {
        title: 'views.delivery_history.table_header.order_id',
        value: 'ORDER_ID',
        field: 'orderId',
    },
];
